import countries from "i18n-iso-countries"

countries.registerLocale(require("i18n-iso-countries/langs/en.json"))
countries.registerLocale(require("i18n-iso-countries/langs/ar.json"))
countries.registerLocale(require("i18n-iso-countries/langs/de.json"))
countries.registerLocale(require("i18n-iso-countries/langs/es.json"))
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"))
countries.registerLocale(require("i18n-iso-countries/langs/it.json"))
countries.registerLocale(require("i18n-iso-countries/langs/nl.json"))
countries.registerLocale(require("i18n-iso-countries/langs/pt.json"))

export const getCountriesByLanguage = languageCode => {
  let lang = "en"
  if (languageCode === "en-gb") lang = "en"
  else if (languageCode) lang = languageCode
  const countriesObject = countries.getNames(lang) || countries.getNames("en")
  return Object.keys(countriesObject).map(x => ({
    value: x,
    name: Array.isArray(countriesObject[x]) ? countriesObject[x][0] : countriesObject[x],
  }))
}

export default getCountriesByLanguage
